import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4176a490"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "admin-login-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Admin Login", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Username", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Password", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Login", -1))
const _hoisted_6 = {
  key: 0,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
          type: "text",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.username]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
          type: "password",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.password]
        ])
      ]),
      _hoisted_5,
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.error), 1))
        : _createCommentVNode("", true)
    ], 32)
  ]))
}